import { State as _DataExecuters } from "./Executors/data/interface";
import { State as _DataModalExecuters } from "./Executors/dataModal/interface";
import { State as _DataModalCarParks } from "./CarParks/dataModal/interface";

export namespace Accounts {
	export namespace Executors {
		export interface DataExecuters extends _DataExecuters {}

		export interface DataModalExecuters extends _DataModalExecuters {}
	}

	export namespace CarParks {
		export interface DataModalCarParks extends _DataModalCarParks {}
	}

	export const ConstantAccountsSlice = {
		EXECUTORS_DATA: "accounts/executors/data",
		EXECUTORS_DATA_MODAL: "accounts/executors/dataModal",
		CAR_PARKS_DATA_MODAL: "accounts/carParks/dataModal",
	};
}
